import React from 'react';
import x4Image from '../../assets/images/icons/8x4-black.png';
import x4WhiteImage from '../../assets/images/icons/8x4-white.png';
import amplirollImage from '../../assets/images/icons/ampliroll-black.png';
import amplirollWhiteImage from '../../assets/images/icons/ampliroll-white.png';
import porteCharImage from '../../assets/images/icons/porte-char-black.png';
import porteCharWhiteImage from '../../assets/images/icons/porte-char-white.png';
import semieImage from '../../assets/images/icons/semie-black.png';
import semieWhiteImage from '../../assets/images/icons/semie-white.png';
import unknownTruckImage from '../../assets/images/icons/unknown-truck-black.png';
import unknownTruckWhiteImage from '../../assets/images/icons/unknown-truck-white.png';
import { useTheme } from '../../hooks/useTheme';

interface TruckIconProps {
    type: 'Semie' | 'Ampliroll' | '8x4' | 'Porte-char' | '';
    style?: React.CSSProperties;
    dark?: boolean;
    disabled?: boolean;
}

const images = {
    Semie: { light: semieImage, dark: semieWhiteImage },
    Ampliroll: { light: amplirollImage, dark: amplirollWhiteImage },
    '8x4': { light: x4Image, dark: x4WhiteImage },
    'Porte-char': { light: porteCharImage, dark: porteCharWhiteImage },
    '': { light: unknownTruckImage, dark: unknownTruckWhiteImage },
};

const TruckIcon: React.FC<TruckIconProps> = ({ type, style, dark = false, disabled = false }) => {
    const imageSrc = images[type] || images[''];
    const { mode } = useTheme();
    return (
        <img
            height={22}
            title={type}
            src={mode === 'dark' ? imageSrc.dark : imageSrc.light}
            alt={`Truck icon ${type}`}
            style={{ opacity: disabled ? 0.6 : 1, ...style }}
        />
    );
};

export default TruckIcon;
